/**
 * Class ModelCache
 *
 * This is the card catalogue of all game information
 * Each game's data is stored in a hash based on game id a la "gid_2014_05_29_texmlb_minmlb_1"
 */
define('GameDayCore/GDModel/storage/ModelCache',['require','exports','module','../../GDControl/GameModelLocator/GameModelLocator','../../GDControl/SubscriptionManager/SubscriptionManager','../../GDControl/TfsManager/TfsManager','extant/extant','../../GDUtil/window/Logg','message-service/message-service','./GameItemModelCache','../enums/datasources/Datasources','./GumboItemModelCache','../../GDUtil/resources/GDConfig','data-fetcher/data-fetcher','../load/execute/FileRequestItem','../../GDUtil/dataMapping/GameReferenceNormalizer','jquery-when-always/jquery-when-always'],function(require,exports,module) {
	var GameModelLocator = require("../../GDControl/GameModelLocator/GameModelLocator"),
        SubsManager = require("../../GDControl/SubscriptionManager/SubscriptionManager"),
        TfsManager = require("../../GDControl/TfsManager/TfsManager"),
        exists = require("extant/extant"),
        logg = require("../../GDUtil/window/Logg"),
        MessageService = require("message-service/message-service"),
        GameItemModelCache = require("./GameItemModelCache"),
		Datasources = require("../enums/datasources/Datasources"),
        GumboItemModelCache = require("./GumboItemModelCache"),
        GDConfig = require("../../GDUtil/resources/GDConfig"),
        dataFetcher = require( "data-fetcher/data-fetcher" ),
        FileRequestItem = require("../load/execute/FileRequestItem"),
		gidVals = require("../../GDUtil/dataMapping/GameReferenceNormalizer"),
        whenAlways = require('jquery-when-always/jquery-when-always').whenAlways;

    var gameHash = { },
		videoItemHash = { };

    /**
     * Function returnGameData
     * @param gameID {String} the identifier for the game you are looking up
     * @param id {String} the unique id for the data request
     * @param value {Object} the value object modelled from the Load
     * @param resource {String} the name of a the resource to store
     *
     * this stores the data that was requested in a unique update repo
     * it decrements the Load counter,
     * which if it reaches 0 dispatches the update event with the data payload
     */
	function returnGameData(gameID, id, value, resource) {
		updateHash[id][resource] = value;

		updateHash[id].returns--;
		if (updateHash[id].returns === 0) {
			logg.log("dispatching data for request " + id);
			setTimeout(function() { MessageService.publish(id, updateHash[id]); }, 50);
		}
	}

    /**
     * Function storeGameData
     * @param gameID {String} game the data's associated with
     * @param datasource {String} the name (from the Enums) of the Load source
     * @param data {Object} the value object modelled from the loaded data
     * @param timestamp {Number} the time the data is being stored (to check for staleness)
     *
     * This function files each value object modelled after Load data in it's proper place
     * Sorted by game id and datasource
     */
    exports.storeGameData = function(gameID, datasourceResponse, timestamp) {
        if (!exists(datasourceResponse,'dataSourceName')) {
            logg.log("you must pass a datasource name type to store it");
            return;
        }
        var datasourceName = datasourceResponse.dataSourceName,
            data = datasourceResponse.data,
            gameItemModel;

        gameID = gidVals.storeVal(gameID);

        timestamp = timestamp || (new Date()).getTime();

        gameItemModel = gameHash[gameID] = gameHash[gameID] || new GameItemModelCache(gameID, timestamp);

        logg.log("storing " + datasourceName + " for game " + gameID);
        if(data && !data.timestamp){
            data.timestamp=timestamp;
        }
        gameItemModel[datasourceName] = {
            timestamp : timestamp,
            data    : data,
            params  : datasourceResponse.params
        };
    };

    /**
     * Function retreiveGameData
     * @param gameID {String}
     * @param datasources {*} can be string, array, object or comma-separated string of sources
     * @returns {Object} a collectiong of just the Datasources requested
     */
    exports.retrieveGameData = function(gameID, datasources) {
		gameID = gidVals.storeVal(gameID);

        var gameItem = gameHash[gameID];

        // null check...
        if (!exists(gameItem)) {
            logg.log("there does not seem to be a game to get data from...");
            return null;
        }

        if (GDConfig.initProps.gumboMode === true) {
            if (exists(gameItem)) {
                return gameItem.gameData;
            } else {
                return null;
            }
        }

        var returnVal = {},
            datasourceList = this.getDatasourceList(datasources),
            datasrc;

        for (var i = 0, len = datasourceList.length; i < len; i++) {
            datasrc = datasourceList[i];
            returnVal[datasrc] = exists(gameItem[datasrc],'data') ? gameItem[datasrc].data : null;
        }

        return returnVal;
    };

    exports.expireDatasources = function(gameID, datasources){
        var i=0,
            datasrc,
            datasrcItem,
            datasourceList = this.getDatasourceList(datasources),
            gameItem = gameHash[gameID],
            len = datasourceList.length,
            tfsActive = TfsManager.syncActive();
            
        for (; i < len; i++) {
            datasrc = datasourceList[i];
            datasrcItem = gameItem[datasrc];
            if(exists(datasrcItem)){
                if(tfsActive){
                    dataFetcher.clearDataSource({
                        "dataSourceName": datasrc,
                        params: datasrcItem.params
                    })
                }

                // skip plays as that was JUST loaded...
                if (datasrc === Datasources.PLAYS || datasrc === Datasources.ALL_INNINGS) {
                    continue;
                }

                dataFetcher.expire({
                    "dataSourceName": datasrc,
                    params: datasrcItem.params
                });
            }
        }

    };

    exports.getDatasourceList = function(datasources){
        var datasourceList = exists(datasources) ? datasources : SubsManager.getSubscriptions();

        if (typeof datasourceList === "string") {
            datasourceList = datasourceList.split(",");
        }
        return datasourceList;

    };
    /**
     * Function getFreshGameData
     * @param gameID {String}
     * @param datasources {*} can be string, array, object or comma-separated string of sources
     * @param updateID {String} unique identifier for this request
     * @param addParams {Object} any attributes to be mix-in'd with the game params for Load pathing
     *
     *  this begins the process of building an object of requested data
     *  some of which may be loaded asynchronously, to then be dispatched via a unique event id
     */
    exports.getFreshGameData = function(gameID, datasources, updateID, addParams, refresh) {
		gameID = gidVals.storeVal(gameID);
        refresh= refresh!==false;

        var gameItem = gameHash[gameID],
            datasrc;
        // null check...
        if (!exists(gameItem)) {
            logg.log("there does not seem to be a game to get data from...");
            return;
        }

        var datasourceList = this.getDatasourceList(datasources),
            requests = [],
            i=0,
            len = datasourceList.length,
            gameParams = GameModelLocator.retrieveGameFromCache(gameID).addGameParams(addParams);

        for (; i < len; i++) {
            // determine datasource
            datasrc = datasourceList[i];
            // let the data-fetcher decide where to get info based on it's datasource definition
            requests.push(dataFetcher.get(new FileRequestItem(datasrc, refresh, gameParams)));
        }
        if(requests.length){
            whenAlways.apply(whenAlways,requests).always(function(){
                var response,
                    responses = arguments,
                    updateHash = {},
                    i = 0,
                    len = responses.length,
                    timestamp = (new Date()).getTime();
                for(; i<len; i++){
                    response = responses[i];
                    updateHash[response.dataSourceName] = exists(response.data) ? response.data : exists(gameItem[response.dataSourceName],'data') ? gameItem[response.dataSourceName].data : null;
                    exports.storeGameData(response.params.gid, response, timestamp);
                }
                //Make the publish async-ish to avoid disptching events
                //before their handlers are applied
                setTimeout(function(){
                    MessageService.publish(updateID, updateHash);
                },0);
            });
        }

    };

    exports.storeGumboData = function(gameID, data) {
        var gameSet;
        if (!exists(gameHash[gameID])) {
            gameHash[gameID] = new GumboItemModelCache(gameID, (new Date()).getTime());
        }

        gameSet = gameHash[gameID];
        logg.log("storing GUMBO for game " + gameID);

        if (exists(data, "metaData.dfeEvents") && data.metaData.dfeEvents[0] === "refresh") {
            gameSet.resetGameData();
        }

        gameSet.gameData.applyNewData(data);
    };

    /**
     * Function checkResourceSellby
     * @param reqName {String}
     * @param lastUpdate {Number}
     * @returns {Boolean}
     *
     * Checks if the requested datasource is old enough to need an update
     * It also has a hard-coded list of things it just will not update
     * as they do not change over the course of a game like the static Resources
     * or files that are on the heartbeat and therefore, by definition up to date
     */
    exports.checkResourceSellby = function(reqName, lastUpdate) {
        switch (reqName) {
            // these are one-time loads
            case Datasources.STATIC_RESOURCES:
            case Datasources.DISPLAY_CONFIG:
            case Datasources.SKIN_CONFIG:
            // these are refreshed often enough to not worry about
            case Datasources.PLAYS:
            case Datasources.BOXSCORE:
            case Datasources.BENCH:
            case Datasources.INNING:
            case Datasources.SCORING_PLAYS:
                return true;
                break;

            default:
                // Let the data fetcher handle the expiration based off of the datesource settings.
                return false;
                // return (exists(lastUpdate) && ((new Date().getTime() - lastUpdate) < (GameDayCore.GDConfig.wait * 1000)));
            break;
        }
    }
});
